module.exports = __webpack_public_path__ + "img/about-us-heading.af33b3a.webp";